import { type RouteLocation, type RouteRecordRaw } from 'vue-router';

import { ROUTE_DATA } from '@/constants/routes.constants';
import { routerHelper } from '@/services/router-helper';

const TriggeringEventOverview = (): unknown => {
    return import(/* webpackPrefetch: true */ './triggering-event-overview-page.vue');
};

export const triggeringEventOverviewRoute: RouteRecordRaw = {
    ...ROUTE_DATA.TRIGGERING_EVENT_OVERVIEW,
    components: {
        main: TriggeringEventOverview
    },
    props: {
        main(route: RouteLocation): { triggeringEventId?: number } {
            return { triggeringEventId: routerHelper.parseParamToInt(route.params.id as string) };
        }
    }
};
